/*
 * @Author: gvodandan 2388176818@qq.com
 * @Date: 2024-11-18 16:24:57
 * @LastEditors: gvodandan 2388176818@qq.com
 * @LastEditTime: 2024-11-26 01:05:08
 * @FilePath: \no035_HotelManage备选1\vue\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import '@/assets/css/theme/index.css'
import BackToListPage from '@/views/BackToListPage'
// import axios1 from './utils/axios1';
import request from "@/utils/request";
// import config from '@/config/config.js' // 倒入默认配置

Vue.config.productionTip = false

Vue.prototype.$request = request
Vue.component('back-list-page', BackToListPage)

// Vue.prototype.$baseUrl = config.baseURL,
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL
// Vue.prototype.$http = axios;

Vue.use(ElementUI, { size: "small" })
// 8-20 邱总：弹窗可拖动指令 v-dialog-drag
import '@/directives/dialogDrag'
Vue.config.errorHandler = function (err, vm, info) {
    console.log('wwwwwwwwwwwwwwwww---------errorHandler------------->err, vm, info:', err, vm, info);
    // 处理错误
    console.error(err);
    // 发送错误日志到服务器
    sendErrorLog(err, vm, info);
    // 展示友好的错误提示给用户
    vm.$notify({
        title: '错误',
        message: '页面发生错误，请稍后重试。',
        type: 'error'
    });
};


function sendErrorLog(err, vm, info) {
    // 这里可以将错误日志发送到服务器
    // 例如：axios.post('/error-log', { err, vm, info });
}

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
